export const TICKET_ADMIN_PERMISSION = 'ticket.admin';
export const TICKET_VIEW_PERMISSION = 'ticket.view';

export const TICKET_SIDENAV_PERMISSION = [TICKET_ADMIN_PERMISSION];

export const TICKET_VIEW_SIDENAV_PERMISSION = [
  TICKET_VIEW_PERMISSION,
  TICKET_ADMIN_PERMISSION,
];
